import {DesktopOutlined, MoonOutlined, SunOutlined} from '@ant-design/icons';
import type {MenuProps} from 'antd';
import ThemeStore, {type ThemeMode} from '../../theme.store';

const modeLabels: Record<ThemeMode, string> = {
    light: 'Светлая тема',
    dark: 'Тёмная тема',
    system: 'Системная тема',
};

export function getThemeMenuItems(): MenuProps['items'] {
    return (['light', 'dark', 'system'] as ThemeMode[]).map((mode) => ({
        key: `theme-${mode}`,
        label: modeLabels[mode],
        icon: mode === 'light'
            ? <SunOutlined />
            : mode === 'dark'
                ? <MoonOutlined />
                : <DesktopOutlined />,
    }));
}

export function handleThemeMenuClick(key: string) {
    if (!key.startsWith('theme-')) return false;
    ThemeStore.setMode(key.replace('theme-', '') as ThemeMode);
    return true;
}

export function getActiveThemeMenuKey(): string {
    return `theme-${ThemeStore.mode}`;
}
